export enum PolicyStatus {
    Active = 1,
    Cancel = 2,
    Modified = 3,
    CancelationApprovalPending = 4,
    ModificationApprovalPending = 5
}